"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[593],{

/***/ 86821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Features_Features; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(50253);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./theme/palette.ts
var palette = __webpack_require__(46054);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/ui/SquareImage.tsx



var SquareImage = function(param) {
    var src = param.src, _containerClassName = param.containerClassName, containerClassName = _containerClassName === void 0 ? "" : _containerClassName, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: containerClassName,
        style: {
            width: "100%",
            position: "relative",
            height: 0,
            paddingBottom: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                position: "absolute",
                top: 0,
                bottom: 0,
                right: 0,
                left: 0
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: src,
                quality: 75,
                layout: "fill",
                objectFit: "cover",
                title: title,
                alt: title
            })
        })
    });
};
/* harmony default export */ var ui_SquareImage = (SquareImage);

;// CONCATENATED MODULE: ./components/home/Features/FeatureItem.tsx






var FeatureItem = function(param) {
    var title = param.title, _subtitle = param.subtitle, subtitle = _subtitle === void 0 ? "" : _subtitle, _hasDivider = param.hasDivider, hasDivider = _hasDivider === void 0 ? false : _hasDivider, icon = param.icon;
    var classes = useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        className: classes.contentContainer,
        children: [
            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: classes.imageContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_SquareImage, {
                    src: icon
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h5",
                className: classes.title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h5",
                component: "h6",
                className: classes.subtitle,
                children: subtitle
            }),
            hasDivider && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: classes.divider
            })
        ]
    });
};
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        contentContainer: (0,_define_property/* default */.Z)({
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center"
        }, theme.breakpoints.up("md"), {
            height: 250
        }),
        imageContainer: (0,_define_property/* default */.Z)({
            width: 50,
            marginTop: theme.spacing(3)
        }, theme.breakpoints.up("md"), {
            marginTop: 0
        }),
        title: (0,_define_property/* default */.Z)({
            fontWeight: 700,
            textTransform: "uppercase",
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1)
        }, theme.breakpoints.up("md"), {
            marginTop: theme.spacing(2)
        }),
        subtitle: (0,_define_property/* default */.Z)({
            marginBottom: theme.spacing(6)
        }, theme.breakpoints.up("md"), {
            marginBottom: 0
        }),
        divider: (0,_define_property/* default */.Z)({
            width: "80%",
            height: 1,
            backgroundColor: palette/* extraPalette.grey.main */.t.grey.main,
            opacity: 0.08
        }, theme.breakpoints.up("md"), {
            position: "absolute",
            right: -theme.spacing(2),
            top: 0,
            width: 1,
            height: "100%"
        })
    };
});
/* harmony default export */ var Features_FeatureItem = (FeatureItem);

;// CONCATENATED MODULE: ./public/icons/gift-box.svg
/* harmony default export */ var gift_box = ({"src":"/_next/static/media/gift-box.ee999f5c.svg","height":512,"width":512});
;// CONCATENATED MODULE: ./public/icons/notebook.svg
/* harmony default export */ var notebook = ({"src":"/_next/static/media/notebook.bc5e5772.svg","height":512,"width":512});
;// CONCATENATED MODULE: ./public/icons/truck.svg
/* harmony default export */ var truck = ({"src":"/_next/static/media/truck.53bf1ef9.svg","height":512,"width":512});
// EXTERNAL MODULE: ./domain/constants/index.ts + 7 modules
var constants = __webpack_require__(74692);
;// CONCATENATED MODULE: ./components/home/Features/Features.tsx









var Features = function() {
    var classes = Features_useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        className: classes.container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Features_FeatureItem, {
                title: "Подарункове пакування",
                subtitle: "для планерів на кільцях та замовлень від 1000 грн",
                hasDivider: true,
                icon: gift_box
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Features_FeatureItem, {
                title: "Безкоштовна доставка",
                subtitle: "від ".concat(constants/* MIN_FREE_DELIVERY_PRICE */.e3, " грн"),
                hasDivider: true,
                icon: truck
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Features_FeatureItem, {
                title: "Корпоративні замовлення",
                subtitle: "брендованої продукції",
                icon: notebook
            })
        ]
    });
};
var Features_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        container: (0,_define_property/* default */.Z)({
            width: "100%",
            marginBottom: theme.spacing(5)
        }, theme.breakpoints.up("md"), {
            display: "grid",
            gap: "".concat(theme.spacing(4), "px ").concat(theme.spacing(4), "px"),
            gridTemplateColumns: "1fr 1fr 1fr",
            marginBottom: theme.spacing(17)
        })
    };
});
/* harmony default export */ var Features_Features = (Features);


/***/ }),

/***/ 49946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



var JsonLd = function(param) {
    var data = param.data, keyName = param.keyName;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: JSON.stringify(data)
            }
        }, keyName)
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (JsonLd);


/***/ }),

/***/ 63189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FeaturedProducts_FeaturedProducts; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./components/ui/Carousel/Carousel.tsx
var Carousel = __webpack_require__(23818);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(50253);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/hooks/useLinkSwipe.ts
var useLinkSwipe = __webpack_require__(41535);
// EXTERNAL MODULE: ./components/ui/links/CustomA.tsx
var CustomA = __webpack_require__(70378);
// EXTERNAL MODULE: ./components/ui/textFormaters/PriceText.tsx
var PriceText = __webpack_require__(88241);
// EXTERNAL MODULE: ./utils/apollo/vars/cartVar.ts
var cartVar = __webpack_require__(87543);
// EXTERNAL MODULE: ./utils/apollo/vars/showCartVar.ts
var showCartVar = __webpack_require__(66660);
// EXTERNAL MODULE: ./utils/helpers/analytics/events.ts + 2 modules
var events = __webpack_require__(23073);
// EXTERNAL MODULE: ./utils/helpers/products/calculatePrice.ts
var calculatePrice = __webpack_require__(23963);
;// CONCATENATED MODULE: ./components/product/FeaturedProducts/FeaturedProductCard.tsx














var FeaturedProductCard = function(param) {
    var product = param.product, _size = param.size, size = _size === void 0 ? "large" : _size;
    var classes = useStyles();
    var ref = (0,useLinkSwipe/* useLinkSwipe */.c)(), handleMouseDown = ref.handleMouseDown, handleClick = ref.handleClick;
    var id = product.sys.id, slug = product.slug, url = product.mainImage.url, name = product.name, price = product.price, discount = product.discount, available = product.available, productItemCode = product.productItemCode, _category = product.category, categorySlug = _category.slug, categoryName = _category.name;
    var color = "color" in product ? product.color : undefined;
    var cartItemIds = "cartItemIds" in product ? product.cartItemIds : undefined;
    var handleBuy = function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (cartItemIds === null || cartItemIds === void 0 ? void 0 : cartItemIds.length) {
            cartItemIds.forEach(function(cartItemId) {
                return (0,cartVar/* addToCart */.Xq)(cartItemId);
            });
        } else {
            (0,cartVar/* addToCart */.Xq)(id);
        }
        (0,showCartVar/* openCart */.LA)();
        events/* default.addToCart */.Z.addToCart(categoryName, name, color, 1, (0,calculatePrice/* calculatePrice */.e)(price, discount), productItemCode);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/shop/".concat(categorySlug, "/").concat(slug),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomA/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: classes.cardContainer,
                onMouseDown: handleMouseDown,
                onClick: handleClick,
                component: "article",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: classes.imageContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: url,
                            quality: 75,
                            width: 284,
                            height: 284,
                            layout: "responsive",
                            sizes: "(max-width: 900px) 50vw, 25vw",
                            className: classnames_default()(classes.image, !available && classes.notAvailable)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        className: classes.content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h3",
                                component: "h3",
                                className: classnames_default()(classes.title, size === "small" && classes.titleSmall),
                                children: name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h5",
                                component: "p",
                                color: "textSecondary",
                                className: classnames_default()(classes.price, size === "small" && classes.priceSmall),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceText/* default */.Z, {
                                    price: price,
                                    discount: discount
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "contained",
                                color: "primary",
                                onClick: handleBuy,
                                disabled: available <= 0,
                                className: classnames_default()(classes.buyButton, available <= 0 && classes.buyButtonNotAvailable),
                                children: available > 0 ? "У кошик" : "Не в наявності"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj;
    return {
        cardContainer: (0,_define_property/* default */.Z)({
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            transition: "box-shadow 500ms"
        }, theme.breakpoints.up("md"), {
            "&:hover": {
                boxShadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.16)",
                "& $image": {
                    transform: "scale(1.07)"
                },
                "& $buyButton": {
                    opacity: 1,
                    pointerEvents: "auto"
                }
            }
        }),
        imageContainer: {
            overflow: "hidden",
            lineHeight: 0
        },
        image: {
            transition: "transform 500ms ease-in"
        },
        notAvailable: {
            opacity: 0.59
        },
        content: (0,_define_property/* default */.Z)({
            width: "100%",
            padding: theme.spacing(1),
            display: "flex",
            flexDirection: "column",
            alignContent: "center",
            textAlign: "center",
            flexGrow: 1
        }, theme.breakpoints.up("md"), {
            padding: theme.spacing(2)
        }),
        title: {
            marginBottom: theme.spacing(2)
        },
        price: {
            marginTop: "auto"
        },
        titleSmall: (_obj = {
            fontSize: "0.875rem"
        }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("sm"), {
            fontSize: "1rem"
        }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
            fontSize: "1.25rem"
        }), _obj),
        priceSmall: (0,_define_property/* default */.Z)({
            fontSize: "0.875rem"
        }, theme.breakpoints.up("md"), {
            fontSize: "1.25rem"
        }),
        buyButton: (0,_define_property/* default */.Z)({
            marginTop: theme.spacing(1.5),
            fontSize: "0.8125rem"
        }, theme.breakpoints.up("md"), {
            marginTop: theme.spacing(2),
            fontSize: "1rem",
            opacity: 0,
            pointerEvents: "none",
            transition: "opacity 300ms"
        }),
        buyButtonNotAvailable: (0,_define_property/* default */.Z)({
            fontSize: "0.6875rem"
        }, theme.breakpoints.up("md"), {
            fontSize: "0.875rem"
        })
    };
});
/* harmony default export */ var FeaturedProducts_FeaturedProductCard = (FeaturedProductCard);

;// CONCATENATED MODULE: ./components/product/FeaturedProducts/FeaturedProducts.tsx






var SLIDES_PER_SIZE = {
    small: {
        sm: 2,
        md: 3,
        lg: 4,
        xl: 4
    },
    large: {
        sm: 1,
        md: 2,
        lg: 3,
        xl: 3
    }
};
var FeaturedProducts = function(param) {
    var products = param.products, _size = param.size, size = _size === void 0 ? "large" : _size;
    var classes = FeaturedProducts_useStyles();
    var ref = (0,useTheme/* default */.Z)(), _breakpoints = ref.breakpoints, breakpoints = _breakpoints.values;
    var autoplay = products.length > SLIDES_PER_SIZE[size].xl;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* default */.Z, {
        settings: {
            slidesToScroll: 2,
            slidesToShow: 1,
            arrows: true,
            infinite: autoplay,
            autoplay: autoplay,
            autoplaySpeed: 5000,
            pauseOnHover: true,
            pauseOnFocus: true,
            responsive: [
                {
                    breakpoint: breakpoints.sm,
                    settings: {
                        slidesToShow: SLIDES_PER_SIZE[size].sm
                    }
                },
                {
                    breakpoint: breakpoints.md,
                    settings: {
                        slidesToShow: SLIDES_PER_SIZE[size].md
                    }
                },
                {
                    breakpoint: breakpoints.lg,
                    settings: {
                        slidesToShow: SLIDES_PER_SIZE[size].lg
                    }
                },
                {
                    breakpoint: 10000,
                    settings: {
                        slidesToShow: SLIDES_PER_SIZE[size].xl
                    }
                }
            ],
            className: classes.container
        },
        children: products.map(function(product) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedProducts_FeaturedProductCard, {
                product: product,
                size: size
            }, product.sys.id);
        })
    });
};
var FeaturedProducts_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj;
    return {
        container: (_obj = {}, (0,_define_property/* default */.Z)(_obj, "& .slick-list", (0,_define_property/* default */.Z)({
            marginLeft: -theme.spacing(2),
            marginRight: -theme.spacing(2)
        }, theme.breakpoints.up("md"), {
            paddingTop: theme.spacing(3),
            paddingBottom: theme.spacing(3),
            marginTop: -theme.spacing(3),
            marginBottom: -theme.spacing(3)
        })), (0,_define_property/* default */.Z)(_obj, "& .slick-track", {
            display: "flex"
        }), (0,_define_property/* default */.Z)(_obj, "& .slick-slide", {
            height: "auto",
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            boxSizing: "border-box"
        }), (0,_define_property/* default */.Z)(_obj, "& .slick-slide > div", {
            height: "100%"
        }), (0,_define_property/* default */.Z)(_obj, "& .slick-slide > div > a", {
            height: "100%",
            display: "flex",
            flexDirection: "column"
        }), _obj)
    };
});
/* harmony default export */ var FeaturedProducts_FeaturedProducts = (FeaturedProducts);


/***/ }),

/***/ 23818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41120);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67814);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51436);











// eslint-disable-next-line no-unused-vars
var SlickButtonFix = function(_param) /*#__PURE__*/ {
    var currentSlide = _param.currentSlide, slideCount = _param.slideCount, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "currentSlide",
        "slideCount",
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
        children: children
    }));
};
var Carousel = function(_param) {
    var children = _param.children, settings = _param.settings, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "children",
        "settings"
    ]);
    var classes = useStyles();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        arrows: false,
        prevArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SlickButtonFix, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                classes: {
                    root: classes.arrow
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_4__/* .FontAwesomeIcon */ .G, {
                    icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faChevronLeft */ .A35
                })
            })
        }),
        nextArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SlickButtonFix, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                classes: {
                    root: classes.arrow
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_4__/* .FontAwesomeIcon */ .G, {
                    icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faChevronRight */ ._tD
                })
            })
        })
    }, settings, props), {
        draggable: true,
        dotsClass: classes.dots,
        children: children
    }));
};
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(theme) {
    var _obj, _obj1, _obj2;
    return {
        dots: (_obj = {
            position: "absolute",
            bottom: theme.spacing(1),
            padding: 0,
            margin: 0,
            left: "50%",
            transform: "translateX(-50%)",
            display: "flex !important",
            gap: 6,
            listStyle: "none"
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, "& .slick-active > button", {
            backgroundColor: theme.palette.common.white
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, "& > li > button", {
            cursor: "pointer",
            borderWidth: 2,
            borderColor: theme.palette.common.white,
            borderStyle: "solid",
            borderRadius: "50%",
            background: "transparent",
            boxShadow: "0px 0px 0px transparent",
            textShadow: "0px 0px 0px transparent",
            fontSize: 1,
            height: 12,
            width: 12,
            color: "transparent",
            padding: 0
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, theme.breakpoints.up("sm"), {
            bottom: theme.spacing(2)
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, theme.breakpoints.up("md"), {
            bottom: theme.spacing(2.5)
        }), _obj),
        arrow: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
            width: 30,
            height: 30,
            fontSize: "0.875rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)"
        }, theme.breakpoints.up("md"), {
            width: 48,
            height: 48,
            fontSize: "inherit",
            backgroundColor: "transparent"
        }),
        "@global": {
            ".slick-next": (_obj1 = {
                position: "absolute",
                right: -16,
                top: "50%",
                transform: "translateY(-50%)"
            }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj1, theme.breakpoints.up("md"), {
                right: -15,
                transform: "none"
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj1, theme.breakpoints.up("lg"), {
                right: -20
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj1, theme.breakpoints.up("xl"), {
                right: -52
            }), _obj1),
            ".slick-prev": (_obj2 = {
                position: "absolute",
                left: -16,
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: 1
            }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj2, theme.breakpoints.up("md"), {
                left: -15,
                transform: "none"
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj2, theme.breakpoints.up("lg"), {
                left: -20
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj2, theme.breakpoints.up("xl"), {
                left: -52
            }), _obj2),
            ".slick-disabled": (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                opacity: 0.4,
                pointerEvents: "none"
            }, theme.breakpoints.up("md"), {
                display: "none"
            })
        }
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (Carousel);


/***/ }),

/***/ 41535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useLinkSwipe; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useLinkSwipe = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), mouseDownTime = ref[0], setMouseDownTime = ref[1];
    var handleMouseDown = function(e) {
        e.preventDefault();
        setMouseDownTime(Date.now());
    };
    var handleClick = function(e) {
        if (typeof mouseDownTime !== "number" || Date.now() - mouseDownTime > 300) {
            e.preventDefault();
        }
    };
    return {
        handleMouseDown: handleMouseDown,
        handleClick: handleClick
    };
};


/***/ })

}]);